import React, { useState, useEffect } from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import Master from './Master';
// import Login from '../components/login/login';
// import Register from '../components/login/register';
// import Forgot from '../components/login/forgot';
// import Otp from '../components/login/otp';
import { getAuthState } from '../assets/scripts/login-util';
import { redirectToLogout } from "../components/api/common";
import Reset from '../components/login/reset';
import VerifyEmail from '../components/login/verifyEmail';
import Invoice from '../components/paymentGateway/invoice';
import GameVerification from '../components/scorecard/gameVerification';
// import MembershipForm from '../components/onboarding/membershipForm';
import { signatureContext } from '../context/context';
// import UserOnboarded from '../components/onboarding/userOnboarded';
// import LoginWithOTP from '../components/login/loginWithOTP';
import PaymentCallback from '../components/paymentGateway/paymentCallback';
import Blocked from '../components/global/blocked';

import PaymentSuccess from '../components/paymentGateway/paymentSuccess';
import PaymentFailure from '../components/paymentGateway/paymentFailure';
import PaymentPending from '../components/paymentGateway/paymentPending';

const App = () => {
    const [auth, setAuth] = useState(getAuthState('bool'));
    const [signatureImg, setSignatureImg] = useState('');

    useEffect(() => {
        const authorized = getAuthState('bool');
        if (authorized === 'Expired') redirectToLogout()
        else {
            setAuth(authorized);
        }
    }, []);

    const authHandler = async () => {
        const authorized = getAuthState('bool');
        authorized === 'Expired' ? setAuth(false) : setAuth(authorized);
    }

    return (
        <BrowserRouter>
            {auth ? (
                <Switch>
                    <Route path="/verify-email" exact>
                        <VerifyEmail />
                    </Route>
                    {/* <Route path="/invoice" exact>
                        <Invoice />
                    </Route> */}
                    {/* <Route path="/membershipForm" exact>
                        <signatureContext.Provider value={signatureImg}>
                            <MembershipForm setSignatureImg={setSignatureImg} />
                        </signatureContext.Provider>
                    </Route> */}
                    {/* <Route path="/user-onboarded" exact>
                        <UserOnboarded />
                    </Route> */}
                    <Route path="/game-verification" exact>
                        <GameVerification />
                    </Route>
                    <Route path="/payment/success">
                        <PaymentSuccess />
                    </Route>
                    <Route path="/payment/failure">
                        <PaymentFailure />
                    </Route>
                    <Route path="/payment/pending">
                        <PaymentPending />
                    </Route>

                    <Route path="/blocked" exact>
                        <Blocked />
                    </Route>

                    {/* <Master auth={auth} /> */}
                     <Redirect to="/blocked" />
                </Switch>

            ) : (
                <Switch>

                    {/* ROUTES BLOCKED AS WEB NO LONGER REQUIRED */}

                    <Route path="/blocked" exact>
                        <Blocked />
                    </Route>

                    {/* <Route path="/login" exact>
                        <Login onLogin={authHandler} />
                    </Route>
                    <Route path="/login-with-otp" exact>
                        <LoginWithOTP onLogin={authHandler} />
                    </Route>
                    <Route path="/registration" exact>
                        <Register onLogin={authHandler} />
                    </Route>
                    <Route path="/forgot-password" exact>
                        <Forgot onLogin={authHandler} />
                    </Route>
                    <Route path="/verify-otp" exact>
                        <Otp onLogin={authHandler} />
                    </Route>
                    <Route path="/reset-password" exact>
                        <Reset onLogin={authHandler} />
                    </Route>
                    <Route path="/verify-email" exact>
                        <VerifyEmail />
                    </Route> */}

                    <Route path="/invoice" exact>
                        <Invoice />
                    </Route>                
                    {/* <Route path="/membershipForm" exact>
                        <signatureContext.Provider value={signatureImg}>
                            <MembershipForm setSignatureImg={setSignatureImg} />
                        </signatureContext.Provider>
                    </Route> */}
                    {/* <Route path="/user-onboarded" exact>
                        <UserOnboarded />
                    </Route> */}

                    <Route path="/game-verification" exact>
                        <GameVerification />
                    </Route>

                    {/* <Route path="/payment-status" exact> */}
                    <Route path="/payment-status">
                        <PaymentCallback/>
                    </Route>

                    <Route path="/payment/success">
                        <PaymentSuccess />
                    </Route>
                    <Route path="/payment/failure">
                        <PaymentFailure />
                    </Route>
                    <Route path="/payment/pending">
                        <PaymentPending />
                    </Route>
                    <Redirect to="/blocked" />
                </Switch>
            )}
        </BrowserRouter>
    );

};

export default App;